// Document rules engine — based on official Algerian import regulations
// Maps SH chapter to required document categories

const CHAPTER_TO_CATS = {
  1:['alim'],2:['viande'],3:['alim','lait'],4:['lait','alim'],5:['alim'],
  6:['veg'],7:['veg','alim'],8:['veg','alim'],9:['alim'],10:['veg','alim'],
  11:['alim'],12:['veg'],15:['alim'],16:['viande','alim'],17:['alim'],18:['alim'],
  19:['alim'],20:['alim'],21:['alim'],22:['alim'],24:['alim'],
  28:['chim'],29:['chim'],30:['pharma'],31:['engrais','veg'],33:['cosm'],38:['pest'],
  39:['indus'],40:['indus'],44:['indus'],48:['indus'],
  50:['elec'],51:['elec'],52:['elec'],53:['elec'],54:['elec'],55:['elec'],
  56:['elec'],57:['elec'],58:['elec'],59:['elec'],60:['elec'],
  61:['elec'],62:['elec'],63:['elec'],64:['elec'],
  68:['constr'],69:['constr'],70:['constr'],
  72:['indus'],73:['indus'],74:['indus'],76:['indus'],
  84:['elec','pieces'],85:['telecom','elec','info'],87:['vehic'],
  90:['mesure','elec'],93:['armes'],
};

export function getDocumentsByChapter(hsCode, countryZone, activityCode, lang) {
  const ar = lang === 'ar';
  const ch = parseInt((hsCode || '').replace(/\./g, '').substring(0, 2));
  const cats = CHAPTER_TO_CATS[ch] || [];
  const L = (fr, a) => ar ? a : fr;

  const docs = { fournisseur: [], importateur: [] };
  const seen = new Set();
  const add = (target, doc) => { if (!seen.has(doc.id)) { seen.add(doc.id); docs[target].push(doc); } };

  // ═══ UNIVERSAL — always required ═══
  add('fournisseur', { id:'facture', nom: L('Facture commerciale définitive','الفاتورة التجارية النهائية'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
    details: L('Document principal pour le dédouanement. Toute erreur ou omission = rejet douanier.','الوثيقة الرئيسية للتخليص الجمركي. أي خطأ أو نقص = رفض جمركي.'),
    mentions: L([
      'Date et numéro de facture',
      'Nom, adresse complète et pays du vendeur',
      'Nom, adresse complète de l\'acheteur algérien',
      'Description PRÉCISE et DÉTAILLÉE de chaque article (pas "marchandises diverses")',
      'Code SH (HS Code) à 10 chiffres pour chaque article',
      'Quantité exacte et unité de mesure (kg, unités, mètres…)',
      'Prix unitaire et prix total par article',
      'Devise de facturation (USD, EUR…)',
      'Incoterm et lieu désigné (ex: FOB Shanghai, CIF Alger)',
      'Pays d\'ORIGINE DE FABRICATION (≠ pays d\'expédition)',
      'Signature manuscrite et cachet du vendeur',
    ],[
      'تاريخ ورقم الفاتورة',
      'اسم وعنوان البائع الكامل والبلد',
      'اسم وعنوان المشتري الجزائري الكامل',
      'وصف دقيق ومفصل لكل منتج (ليس "بضائع متنوعة")',
      'رمز النظام المنسق (HS Code) من 10 أرقام لكل منتج',
      'الكمية الدقيقة ووحدة القياس (كغ، وحدات، أمتار...)',
      'السعر الوحدوي والإجمالي لكل منتج',
      'عملة الفوترة (USD، EUR...)',
      'شرط التسليم والمكان المحدد (مثال: FOB شنغهاي، CIF الجزائر)',
      'بلد المنشأ الحقيقي للصنع (≠ بلد الشحن)',
      'التوقيع اليدوي وختم البائع',
    ]),
    warning: L('Erreur fréquente : désignation trop vague → rejet. La description doit correspondre exactement au code SH.','خطأ شائع: وصف غامض → رفض. يجب أن يتطابق الوصف تماماً مع رمز SH.') });

  add('fournisseur', { id:'packing', nom: L('Liste de colisage (Packing List)','قائمة التعبئة (Packing List)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
    details: L('Doit être strictement cohérente avec la facture. Tout écart = blocage douanier.','يجب أن تكون متوافقة تماماً مع الفاتورة. أي اختلاف = حجز جمركي.'),
    mentions: L([
      'Référence de la facture correspondante',
      'Détail par colis : numéro du colis, contenu exact',
      'Poids brut et poids net de chaque colis',
      'Dimensions de chaque colis (si pertinent)',
      'Nombre total de colis',
      'Poids total brut et net de l\'expédition',
    ],[
      'مرجع الفاتورة المقابلة',
      'تفصيل لكل طرد: رقم الطرد، المحتوى الدقيق',
      'الوزن الإجمالي والصافي لكل طرد',
      'أبعاد كل طرد (إذا كان ذلك مناسباً)',
      'العدد الإجمالي للطرود',
      'الوزن الإجمالي والصافي للشحنة',
    ]) });

  add('fournisseur', { id:'bl', nom: L('Connaissement (Bill of Lading) ou LTA','سند الشحن (Bill of Lading) أو بوليصة الشحن الجوي'), obligatoire: true, timing: L('Après expédition','بعد الشحن'),
    details: L('Émis par la compagnie maritime/aérienne. L\'original endossé est requis pour la domiciliation bancaire.','يصدر من شركة الشحن البحري/الجوي. النسخة الأصلية المظهرة مطلوبة للتوطين البنكي.'),
    mentions: L([
      'Nom du chargeur (expéditeur) et du destinataire',
      'Description de la marchandise conforme à la facture',
      'Nombre de colis et poids total',
      'Port/aéroport de chargement',
      'Port/aéroport de déchargement',
      'Numéro du connaissement/LTA',
    ],[
      'اسم الشاحن (المرسل) والمرسل إليه',
      'وصف البضاعة مطابق للفاتورة',
      'عدد الطرود والوزن الإجمالي',
      'ميناء/مطار التحميل',
      'ميناء/مطار التفريغ',
      'رقم سند الشحن/بوليصة الشحن',
    ]) });

  add('fournisseur', { id:'fiche_tech', nom: L('Fiche technique du produit','البطاقة التقنية للمنتج'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
    details: L('Obligatoire pour le contrôle de conformité à la frontière. NON ACCEPTÉE en anglais seul — doit être en français ou arabe.','إلزامية لمراقبة المطابقة على الحدود. لا تُقبل بالإنجليزية فقط — يجب أن تكون بالفرنسية أو العربية.'),
    mentions: L([
      'Dénomination commerciale exacte du produit',
      'Caractéristiques techniques détaillées',
      'Normes de fabrication appliquées (ISO, CE, NF…)',
      'Pays de fabrication',
      'Nom et adresse complète du fabricant',
      'Langue : français ou arabe (pas anglais seul)',
    ],[
      'التسمية التجارية الدقيقة للمنتج',
      'الخصائص التقنية المفصلة',
      'معايير التصنيع المطبقة (ISO، CE، NF...)',
      'بلد الصنع',
      'اسم وعنوان المصنع الكامل',
      'اللغة: الفرنسية أو العربية (ليس الإنجليزية فقط)',
    ]),
    warning: L('Refusée si en anglais uniquement.','تُرفض إذا كانت بالإنجليزية فقط.') });

  // Certificate of origin based on zone
  if (countryZone === 'EU') {
    add('fournisseur', { id:'eur1', nom: L('Certificat EUR.1','شهادة EUR.1'), obligatoire: false, recommande: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Permet DD = 0% au lieu du taux normal. Validité 10 mois. Le DAPS s\'applique quand même.','يسمح بالرسوم الجمركية = 0% بدل المعدل العادي. صالحة 10 أشهر. الرسم الإضافي يُطبق رغم ذلك.'),
      mentions: L([
        'Numéro de référence EUR.1',
        'Nom, adresse et pays de l\'exportateur',
        'Nom et adresse de l\'importateur algérien',
        'Description de la marchandise + code HS',
        'Pays d\'origine des marchandises',
        'Cachet officiel de la douane du pays exportateur',
        'Signature de l\'exportateur',
      ],[
        'رقم مرجع EUR.1',
        'اسم وعنوان وبلد المصدر',
        'اسم وعنوان المستورد الجزائري',
        'وصف البضاعة + رمز HS',
        'بلد منشأ البضائع',
        'ختم رسمي من جمارك البلد المصدر',
        'توقيع المصدر',
      ]),
      howto: L('Le fournisseur le demande à sa Chambre de Commerce + visa douane. Alternative si < 6 000 EUR : déclaration sur facture.','يطلبه المورد من غرفة التجارة + تأشيرة الجمارك. بديل إذا أقل من 6,000 يورو: تصريح على الفاتورة.') });
  } else if (countryZone === 'GZALE') {
    add('fournisseur', { id:'cert_gzale', nom: L('Certificat d\'origine GZALE (en arabe)','شهادة المنشأ العربية (GZALE)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Permet DD = 0%. Doit être rédigé intégralement en arabe.','يسمح بالرسوم الجمركية = 0%. يجب أن يكون محرراً بالكامل بالعربية.'),
      mentions: L([
        'Rédigé intégralement en langue arabe',
        'Nom et adresse de l\'exportateur',
        'Nom et adresse de l\'importateur algérien',
        'Description détaillée de la marchandise',
        'Pays d\'origine',
        'Cachet et signature de la Chambre de Commerce',
        'Visa des autorités compétentes du pays',
      ],[
        'محرر بالكامل باللغة العربية',
        'اسم وعنوان المصدر',
        'اسم وعنوان المستورد الجزائري',
        'وصف مفصل للبضاعة',
        'بلد المنشأ',
        'ختم وتوقيع غرفة التجارة',
        'تأشيرة السلطات المختصة في البلد',
      ]),
      howto: L('Demander au fournisseur de le faire établir par sa Chambre de Commerce, en arabe.','اطلب من المورد إصداره من غرفة التجارة، باللغة العربية.') });
  } else {
    add('fournisseur', { id:'cert_std', nom: L('Certificat d\'origine standard','شهادة المنشأ العادية'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Obligatoire pour les douanes algériennes. Doit mentionner le pays de fabrication réelle (pas le pays d\'expédition).','إلزامية للجمارك الجزائرية. يجب ذكر بلد الصنع الحقيقي (وليس بلد الشحن).'),
      mentions: L([
        'Nom et adresse de l\'exportateur',
        'Nom et adresse de l\'importateur',
        'Description de la marchandise',
        'Pays d\'ORIGINE DE FABRICATION (pas le pays d\'expédition)',
        'Cachet de la Chambre de Commerce du pays exportateur',
      ],[
        'اسم وعنوان المصدر',
        'اسم وعنوان المستورد',
        'وصف البضاعة',
        'بلد المنشأ الحقيقي للصنع (وليس بلد الشحن)',
        'ختم غرفة التجارة في البلد المصدر',
      ]),
      howto: L('Demander au fournisseur de le faire émettre par sa Chambre de Commerce locale.','اطلب من المورد إصداره من غرفة التجارة المحلية.') });
  }

  // Importateur universal
  add('importateur', { id:'ppi', nom: L('PPI validé — statut "Traité" (import.mcepe.gov.dz)','البرنامج التقديري المصادق عليه — حالة "معالج" (import.mcepe.gov.dz)'), obligatoire: true, timing: L('Avant domiciliation','قبل التوطين البنكي'),
    details: L('Obligatoire depuis juillet 2025. Sans PPI = domiciliation impossible.','إلزامي منذ جويلية 2025. بدون برنامج تقديري = استحالة التوطين.') });
  add('importateur', { id:'domiciliation', nom: L('Domiciliation bancaire','التوطين البنكي'), obligatoire: true, timing: L('Avant domiciliation','قبل التوطين البنكي'),
    details: L('Ouvrir dès réception du BL. Nécessite PPI validé + TDB payée (si applicable).','يُفتح فور استلام سند الشحن. يتطلب برنامج تقديري مصادق + رسم التوطين (إن وجد).') });
  add('importateur', { id:'rc', nom: L('Extrait du Registre du Commerce','مستخرج السجل التجاري'), obligatoire: true, timing: L('Pour dossier douanier','لملف الجمارك'),
    details: L('À jour, correspondant au code activité déclaré.','ساري المفعول، مطابق لرمز النشاط المصرح به.') });
  add('importateur', { id:'etiq', nom: L('Conformité étiquetage arabe','مطابقة الوسم بالعربية'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
    details: L('Loi n°09-03 : mentions en arabe à titre principal. GTIN GS1 obligatoire pour produits préemballés.','القانون 09-03: البيانات بالعربية بصفة رئيسية. الرمز الشريطي GS1 إلزامي للمنتجات المعبأة مسبقاً.') });

  // ═══ CATEGORY-SPECIFIC ═══
  if (cats.includes('alim')) {
    add('fournisseur', { id:'cert_labo', nom: L('Certificat d\'analyse de laboratoire','شهادة تحليل مخبري'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Composition, analyses microbiologiques et chimiques, n° lot, date production. Labo accrédité.','التركيبة، التحاليل الميكروبيولوجية والكيميائية، رقم الحصة، تاريخ الإنتاج. مخبر معتمد.') });
    add('fournisseur', { id:'haccp', nom: L('Certificat HACCP ou ISO 22000','شهادة HACCP أو ISO 22000'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Bonnes pratiques de fabrication alimentaire.','ممارسات التصنيع الغذائي الجيدة.') });
  }
  if (cats.includes('viande')) {
    add('fournisseur', { id:'cert_vet', nom: L('Certificat sanitaire vétérinaire officiel','الشهادة الصحية البيطرية الرسمية'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Délivré par l\'autorité vétérinaire officielle du pays exportateur. Un certificat par lot.','صادرة من السلطة البيطرية الرسمية في البلد المصدر. شهادة لكل حصة.'),
      mentions: L([
        'N° d\'agrément de l\'établissement d\'abattage',
        'Espèce animale et catégorie de produit',
        'Numéro de lot et date d\'abattage',
        'Attestation de bonne santé animale',
        'Absence de maladies listées par l\'OIE',
        'Conformité aux exigences sanitaires algériennes',
        'Signature et cachet du vétérinaire officiel du pays',
      ],[
        'رقم اعتماد مؤسسة الذبح',
        'نوع الحيوان وفئة المنتج',
        'رقم الحصة وتاريخ الذبح',
        'شهادة صحة حيوانية جيدة',
        'غياب الأمراض المدرجة في قائمة OIE',
        'المطابقة للمتطلبات الصحية الجزائرية',
        'توقيع وختم الطبيب البيطري الرسمي للبلد',
      ]),
      howto: L('Le fournisseur contacte son autorité vétérinaire nationale pour inspection et certification.','يتصل المورد بالسلطة البيطرية الوطنية للتفتيش والتصديق.') });
    add('fournisseur', { id:'halal', nom: L('Certificat halal','شهادة حلال'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('L\'organisme certificateur doit être reconnu par les autorités algériennes.','يجب أن تكون هيئة التصديق معترفاً بها من السلطات الجزائرية.'),
      mentions: L([
        'Nom de l\'organisme de certification halal',
        'N° de certificat et date de validité',
        'Identification du produit et du lot',
        'Attestation que l\'abattage est conforme au rite islamique',
        'Signature et cachet de l\'organisme',
      ],[
        'اسم هيئة التصديق الحلال',
        'رقم الشهادة وتاريخ الصلاحية',
        'تعريف المنتج والحصة',
        'شهادة أن الذبح مطابق للشريعة الإسلامية',
        'توقيع وختم الهيئة',
      ]),
      howto: L('Organismes reconnus (France) : Grande Mosquée de Paris, ARGML, HCF.','الهيئات المعترف بها (فرنسا): مسجد باريس الكبير، ARGML، HCF.') });
  }
  if (cats.includes('lait')) {
    add('fournisseur', { id:'cert_vet_lait', nom: L('Certificat sanitaire vétérinaire — produits laitiers','الشهادة الصحية البيطرية — منتجات الألبان'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Absence brucellose/tuberculose. Composition (MG, protéines, eau).','غياب البروسيلا/السل. التركيبة (المادة الدهنية، البروتينات، الماء).') });
  }
  if (cats.includes('veg')) {
    add('fournisseur', { id:'phyto', nom: L('Certificat phytosanitaire officiel','الشهادة الصحية النباتية الرسمية'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Délivré par le service phytosanitaire officiel (ONPV) du pays exportateur. Un certificat par expédition.','صادرة من المصلحة الصحية النباتية الرسمية (ONPV) في البلد المصدر. شهادة لكل شحنة.'),
      mentions: L([
        'Nom de l\'organisme national de protection des végétaux (ONPV)',
        'Nom et adresse de l\'exportateur',
        'Description botanique précise du produit',
        'Quantité déclarée',
        'Attestation d\'inspection phytosanitaire',
        'Absence d\'organismes nuisibles réglementés',
        'Traitements phytosanitaires effectués (produits, doses, dates)',
        'Date d\'émission et signature officielle',
      ],[
        'اسم الهيئة الوطنية لحماية النباتات (ONPV)',
        'اسم وعنوان المصدر',
        'الوصف النباتي الدقيق للمنتج',
        'الكمية المصرح بها',
        'شهادة التفتيش الصحي النباتي',
        'غياب الكائنات الضارة المنظمة',
        'المعالجات الصحية النباتية المنفذة (المنتجات، الجرعات، التواريخ)',
        'تاريخ الإصدار والتوقيع الرسمي',
      ]),
      howto: L('Le fournisseur contacte le service phytosanitaire officiel de son pays pour inspection avant expédition.','يتصل المورد بالمصلحة الصحية النباتية الرسمية في بلده للتفتيش قبل الشحن.') });
  }
  if (cats.includes('pharma')) {
    add('importateur', { id:'amm', nom: L('Enregistrement AMM auprès de l\'ANPP','تسجيل رخصة التسويق لدى ANPP'), obligatoire: true, timing: L('AVANT commande (12-36 mois)','قبل الطلب (12-36 شهراً)'),
      details: L('CRITIQUE : Sans AMM algérienne, importation impossible.','حرج: بدون رخصة تسويق جزائرية، الاستيراد مستحيل.'),
      warning: L('Vérifier d\'abord si le produit est déjà enregistré auprès de l\'ANPP avant toute démarche.','تحقق أولاً إذا كان المنتج مسجلاً لدى ANPP قبل أي إجراء.') });
    add('fournisseur', { id:'bpf', nom: L('Certificat BPF/GMP','شهادة ممارسات التصنيع الجيدة (GMP)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Délivré par l\'autorité de santé du pays fabricant. Doit être en cours de validité.','صادرة من سلطة الصحة في بلد الصنع. يجب أن تكون سارية المفعول.'),
      mentions: L([
        'Nom et adresse du site de fabrication',
        'Produits pharmaceutiques couverts par le certificat',
        'Autorité de santé qui a délivré le certificat',
        'Date de délivrance et date de validité',
        'Résultat de la dernière inspection BPF',
      ],[
        'اسم وعنوان موقع التصنيع',
        'المنتجات الصيدلانية المشمولة بالشهادة',
        'سلطة الصحة التي أصدرت الشهادة',
        'تاريخ الإصدار وتاريخ الصلاحية',
        'نتيجة آخر تفتيش GMP',
      ]) });
    add('fournisseur', { id:'coa', nom: L('Certificat d\'analyse par lot (CoA)','شهادة تحليل لكل حصة (CoA)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Un certificat par lot expédié. Les tests doivent être conformes à la pharmacopée de référence.','شهادة لكل حصة مشحونة. يجب أن تكون الاختبارات مطابقة لدستور الأدوية المرجعي.'),
      mentions: L([
        'Numéro de lot',
        'Date de fabrication et date de péremption',
        'Résultats de TOUS les tests de la pharmacopée',
        'Spécifications attendues vs résultats obtenus',
        'Signature du pharmacien responsable qualité',
      ],[
        'رقم الحصة',
        'تاريخ الصنع وتاريخ انتهاء الصلاحية',
        'نتائج جميع اختبارات دستور الأدوية',
        'المواصفات المتوقعة مقابل النتائج المحصلة',
        'توقيع الصيدلي المسؤول عن الجودة',
      ]) });
  }
  if (cats.includes('cosm')) {
    add('importateur', { id:'auto_cosm', nom: L('Autorisation préalable cosmétiques','الترخيص المسبق لمستحضرات التجميل'), obligatoire: true, timing: L('AVANT commande (~60 jours)','قبل الطلب (~60 يوماً)'),
      details: L('Décret n°97-37. À obtenir AVANT de passer commande.','المرسوم 97-37. يجب الحصول عليه قبل تقديم الطلب.'),
      mentions: L([
        'Extrait RC légalisé de l\'importateur',
        'Statuts de la société légalisés',
        'Dénomination et désignation exacte du produit',
        'Composition qualitative complète (liste INCI)',
        'Fiche de sécurité du produit',
        'Autorisation d\'exploitation de la marque (si marque étrangère)',
      ],[
        'مستخرج السجل التجاري المصادق عليه للمستورد',
        'القانون الأساسي للشركة المصادق عليه',
        'التسمية والتعيين الدقيق للمنتج',
        'التركيبة النوعية الكاملة (قائمة INCI)',
        'بطاقة سلامة المنتج',
        'ترخيص استغلال العلامة التجارية (إذا كانت علامة أجنبية)',
      ]),
      howto: L('Déposer le dossier à la Direction du Commerce de votre wilaya.','إيداع الملف لدى مديرية التجارة لولايتك.') });
    add('fournisseur', { id:'clc', nom: L('Certificat de libre commercialisation (CLC)','شهادة حرية التسويق'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Atteste que le produit est légalement commercialisé dans le pays d\'origine.','تشهد أن المنتج يُسوق قانونياً في بلد المنشأ.'),
      howto: L('Délivré par l\'autorité de santé ou de commerce du pays exportateur.','تصدر من سلطة الصحة أو التجارة في البلد المصدر.') });
  }
  if (cats.includes('telecom')) {
    add('importateur', { id:'arpce', nom: L('Homologation ARPCE','مصادقة ARPCE'), obligatoire: true, timing: L('AVANT commande (30-60 jours)','قبل الطلب (30-60 يوماً)'),
      details: L('Loi n°18-04. Tout équipement émettant/recevant des ondes radio.','القانون 18-04. كل جهاز يبث/يستقبل موجات راديو.'),
      mentions: L([
        'Dossier technique complet du produit',
        'Certificats de conformité CE ou FCC',
        'Rapports de tests CEM (compatibilité électromagnétique)',
        'Tests SAR pour téléphones (débit d\'absorption spécifique)',
        'Bandes de fréquences utilisées (doivent être compatibles Algérie)',
      ],[
        'ملف تقني كامل للمنتج',
        'شهادات المطابقة CE أو FCC',
        'تقارير اختبارات التوافق الكهرومغناطيسي (CEM)',
        'اختبارات SAR للهواتف (معدل الامتصاص النوعي)',
        'نطاقات التردد المستخدمة (يجب أن تكون متوافقة مع الجزائر)',
      ]),
      warning: L('⚠️ Sans homologation = saisie à la frontière. Concerne : téléphones, routeurs, WiFi, Bluetooth, antennes.','⚠️ بدون مصادقة = حجز على الحدود. يشمل: الهواتف، الراوترات، WiFi، Bluetooth، الهوائيات.') });
  }
  if (cats.includes('chim')) {
    add('fournisseur', { id:'fds', nom: L('Fiche de Données de Sécurité (FDS/SDS)','صحيفة بيانات السلامة (SDS)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Obligatoire pour tout produit chimique. Doit être conforme au règlement GHS. En français ou arabe.','إلزامية لكل منتج كيميائي. يجب أن تكون مطابقة لنظام GHS. بالفرنسية أو العربية.'),
      mentions: L([
        '16 sections conformes au règlement GHS/CLP :',
        '1. Identification du produit et de la société',
        '2. Identification des dangers',
        '3. Composition / informations sur les composants',
        '4. Mesures de premiers secours',
        '5. Mesures de lutte contre l\'incendie',
        '6. Mesures en cas de dispersion accidentelle',
        '7. Manipulation et stockage',
        '8. Contrôle de l\'exposition / protection individuelle',
        '9. Propriétés physiques et chimiques',
        '10-16. Stabilité, toxicologie, écologie, élimination, transport, réglementation',
        'Langue : français ou arabe obligatoire',
      ],[
        '16 قسماً وفقاً لنظام GHS/CLP:',
        '1. تعريف المنتج والشركة',
        '2. تحديد المخاطر',
        '3. التركيبة / معلومات عن المكونات',
        '4. إجراءات الإسعافات الأولية',
        '5. إجراءات مكافحة الحريق',
        '6. إجراءات في حالة الانسكاب العرضي',
        '7. المناولة والتخزين',
        '8. مراقبة التعرض / الحماية الشخصية',
        '9. الخصائص الفيزيائية والكيميائية',
        '10-16. الاستقرار، السمية، البيئة، التخلص، النقل، التنظيم',
        'اللغة: الفرنسية أو العربية إلزامية',
      ]) });
  }
  if (cats.includes('indus')) {
    add('fournisseur', { id:'mtc', nom: L('Certificat qualité par lot (Mill Test Certificate)','شهادة الجودة لكل حصة (MTC)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Composition chimique, propriétés mécaniques, n° coulée, norme (EN/ASTM/ISO).','التركيبة الكيميائية، الخصائص الميكانيكية، رقم الصب، المعيار (EN/ASTM/ISO).') });
  }
  if (cats.includes('vehic')) {
    add('fournisseur', { id:'coc', nom: L('Certificat de conformité constructeur (COC)','شهادة مطابقة المصنع (COC)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('VIN, caractéristiques techniques, normes Euro, émissions CO2.','رقم الهيكل VIN، الخصائص التقنية، معايير Euro، انبعاثات CO2.') });
    add('importateur', { id:'cnsr', nom: L('Homologation CNSR','مصادقة المركز الوطني للأمن على الطرقات'), obligatoire: true, timing: L('AVANT commande','قبل الطلب'),
      details: L('Le type de véhicule doit être homologué en Algérie.','يجب أن يكون نوع المركبة مصادقاً عليه في الجزائر.') });
  }
  if (cats.includes('constr')) {
    add('fournisseur', { id:'na_constr', nom: L('Certificat conformité normes algériennes (NA)','شهادة المطابقة للمعايير الجزائرية (NA)'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('IANOR. Requis pour ciment, carrelage, verre, barres armature.','المعهد الجزائري للتقييس. مطلوب للإسمنت، البلاط، الزجاج، قضبان التسليح.') });
  }
  if (cats.includes('mesure')) {
    add('fournisseur', { id:'etalon', nom: L('Certificat d\'étalonnage','شهادة المعايرة'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Obligatoire pour instruments légaux de mesure (balances, compteurs, débitmètres).','إلزامي لأدوات القياس القانونية (الموازين، العدادات، مقاييس التدفق).') });
  }
  if (cats.includes('pest')) {
    add('importateur', { id:'ati', nom: L('Autorisation Technique INPV','الترخيص التقني INPV'), obligatoire: true, timing: L('AVANT commande','قبل الطلب'),
      details: L('Obligatoire pour tout pesticide/herbicide/fongicide. Produit doit être homologué en Algérie.','إلزامي لكل مبيد حشري/أعشاب/فطري. المنتج يجب أن يكون مصادقاً عليه في الجزائر.') });
  }
  if (cats.includes('engrais')) {
    add('fournisseur', { id:'analyse_engrais', nom: L('Certificat d\'analyse NPK','شهادة تحليل NPK'), obligatoire: true, timing: L('Avant expédition','قبل الشحن'),
      details: L('Teneurs NPK, métaux lourds, granulométrie, humidité, n° lot.','محتويات NPK، المعادن الثقيلة، حجم الحبيبات، الرطوبة، رقم الحصة.') });
  }

  // TDB
  if (activityCode === '04') {
    add('importateur', { id:'tdb', nom: L('Quittance TDB (0.3% min 20 000 DZD)','وصل رسم التوطين البنكي (0.3% الحد الأدنى 20,000 د.ج)'), obligatoire: true, timing: L('Avant domiciliation','قبل التوطين'),
      details: L('Payer à la recette des impôts AVANT domiciliation. Exonéré pour codes 01/07.','يُدفع لدى قباضة الضرائب قبل التوطين. معفى لرموز النشاط 01/07.') });
  } else if (activityCode === '07') {
    add('importateur', { id:'tdb', nom: L('Quittance TDB services (4%)','وصل رسم التوطين البنكي للخدمات (4%)'), obligatoire: true, timing: L('Avant domiciliation','قبل التوطين'),
      details: L('TDB services = 4% du montant.','رسم التوطين للخدمات = 4% من المبلغ.') });
  }

  return docs;
}
